const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
		this.isOpen = false

    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.fetchHtml(productHandle);
      },
    });

    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.isOpen) this.close();
    });
  }

  fetchHtml(productHandle) {
    loadAssetsNew([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], "quick-view-assets");
    fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector(".m-product-quickview");
        const firstModel = html.querySelector("product-model");
        this.mediaGallery = this.modalContent.querySelector("media-gallery");
        loadAssetsNew([MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory], "variants-picker", () => {
          const colorScheme = this.modalContent.dataset.colorScheme;
          this.modal.appendChild(this.modalContent);
          this.modal.setWidth("960px");
          this.modal.open();
          this.modal.setSizes(`m-gradient ${colorScheme}`);
          this.initMediaLoaders(this.modalContent);
          this.initByteGalleryNav(this.modalContent);
					this.toggleLoading(this.target, false)
					this.isOpen = true
        });
        if (firstModel) {
          loadAssetsNew(
            [
              MinimogThemeScripts.productModel,
              "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            ],
            "product-model-assets"
          );
        }
      })
      .catch(console.error);
  }

  close(e) {
    this.modal.close(e)
    this.isOpen = false
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add("m-spinner-loading");
    } else {
      target.classList.remove("m-spinner-loading");
    }
  }

  // byte-product.js only loads on product templates, so Quick View must hide
  // .byteLoader itself when media is injected into the modal.
  initMediaLoaders(root) {
    if (!root) return;

    const hideLoader = (img) => {
      const media = img.closest(".byteMedia");
      if (!media) return;

      media.classList.add("media-loaded", "is-loaded");

      const loader = media.querySelector(".byteLoader");
      if (loader) {
        loader.style.setProperty("display", "none", "important");
        loader.setAttribute("hidden", "");
      }
    };

    const images = root.querySelectorAll(".byteMedia .byte-media-image, .byteMedia > img, .byteMedia img");

    for (const img of images) {
      if (img.dataset.quickViewLoaderBound === "true") continue;
      img.dataset.quickViewLoaderBound = "true";

      if (img.complete && img.naturalWidth > 0) {
        hideLoader(img);
        continue;
      }

      img.addEventListener("load", () => hideLoader(img), { once: true });
      img.addEventListener("error", () => hideLoader(img), { once: true });
    }

    // Fallback: if images already painted/cached without firing load, force-hide soon after.
    requestAnimationFrame(() => {
      for (const img of images) {
        if (img.complete) hideLoader(img);
      }
    });
  }

  // layout-4 uses byteMain (not Swiper). Wire prev/next to cycle .byte-active.
  initByteGalleryNav(root) {
    if (!root) return;

    const galleries = root.querySelectorAll(".byteMain");
    for (const byteMain of galleries) {
      if (byteMain.dataset.byteNavBound === "true") continue;

      const slides = Array.from(byteMain.querySelectorAll(".byte1"));
      if (slides.length < 2) continue;

      const prevBtn = byteMain.querySelector(".swiper-button-prev");
      const nextBtn = byteMain.querySelector(".swiper-button-next");
      if (!prevBtn && !nextBtn) continue;

      byteMain.dataset.byteNavBound = "true";

      const goTo = (direction) => {
        const currentIndex = slides.findIndex((slide) =>
          slide.classList.contains("byte-active")
        );
        const activeIndex = currentIndex < 0 ? 0 : currentIndex;
        const nextIndex =
          (activeIndex + direction + slides.length) % slides.length;

        slides[activeIndex].classList.remove("byte-active");
        slides[nextIndex].classList.add("byte-active");
      };

      if (prevBtn) {
        prevBtn.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          goTo(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          goTo(1);
        });
      }
    }
  }
}

MinimogTheme.ProductQuickView = new QuickView();
